/** Pure formatting helpers (client-side duplicate of server fmtTime). */
export function fmtTime(minutes: number): string {
  const m = ((minutes % (24 * 60)) + 24 * 60) % (24 * 60);
  const hh = Math.floor(m / 60);
  const mm = m % 60;
  const period = hh < 12 || hh === 24 ? "AM" : "PM";
  let hr = hh % 12;
  if (hr === 0) hr = 12;
  return `${hr}:${String(mm).padStart(2, "0")} ${period}`;
}

const WEEKDAYS_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;
const MONTHS_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
] as const;

/**
 * Build an array of day labels ("Fri · Jul 17", "Sat · Jul 18", …) starting
 * at `startDate` (ISO YYYY-MM-DD), length = `days`. Day numbers in the
 * schedule are 1-indexed; index 0 here corresponds to `day === 1`.
 *
 * Pure — accepts a plain string so it's testable without DOM or timezone quirks.
 */
export function dayLabels(startDateIso: string, days: number, opts: { dot?: boolean } = {}): string[] {
  const sep = opts.dot === false ? " " : " · ";
  const parts = startDateIso.split("-").map(Number);
  if (parts.length !== 3 || parts.some(n => !Number.isFinite(n))) {
    // Malformed input — return plain "Day N" fallbacks so callers never crash.
    return Array.from({ length: days }, (_, i) => `Day ${i + 1}`);
  }
  const [y, m, d] = parts as [number, number, number];
  const labels: string[] = [];
  // Use UTC math so daylight-saving boundaries can't shift labels locally.
  const t0 = Date.UTC(y, m - 1, d);
  for (let i = 0; i < days; i++) {
    const dt = new Date(t0 + i * 86_400_000);
    const wd = WEEKDAYS_SHORT[dt.getUTCDay()]!;
    const mo = MONTHS_SHORT[dt.getUTCMonth()]!;
    labels.push(`${wd}${sep}${mo} ${dt.getUTCDate()}`);
  }
  return labels;
}
